import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'

/** Çoklu seçim: seçenekler çip olarak listelenir, tıklayınca eklenir/çıkarılır. */
export function ChipsPicker({ id, options, value, onChange, empty }: { id: string; options: { value: string; label: string }[]; value: string[]; onChange: (v: string[]) => void; empty?: string }) {
  if (!options.length) return <p className="text-xs text-muted-foreground">{empty}</p>
  const toggle = (v: string) => onChange(value.includes(v) ? value.filter((x) => x !== v) : [...value, v])
  return (
    <div id={id} role="group" className="flex flex-wrap gap-1.5">
      {options.map((o) => {
        const on = value.includes(o.value)
        return (
          <button
            key={o.value}
            type="button"
            aria-pressed={on}
            onClick={() => toggle(o.value)}
            className={cn(
              'inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
              on ? 'border-primary/40 bg-primary/10 text-primary' : 'bg-card hover:bg-muted',
            )}
          >
            {on ? <Check className="size-3" aria-hidden /> : null}
            {o.label}
          </button>
        )
      })}
    </div>
  )
}
